<template lang="html">
  <nav :class="{ active: menuActive }">
    <div class="title" @click="menuActive = !menuActive">
      MENU
    </div>
    <div v-if="menuActive" class="links" @click="menuActive = false">
      <div class="link" @click="goTo('paintings')">Paintings</div>
      <div class="link" @click="goTo('drawings')">Drawings</div>
      <div class="link" @click="goTo('other')">Other</div>
      <div class="link" @click="goTo('editorial')">Editorial</div>
      <div class="link" @click="goTo('curatorial')">Curatorial</div>
      <!-- <router-link :to="{ name: 'drawings' }">Drawings</router-link>
      <router-link :to="{ name: 'other' }">Other</router-link>
      <router-link :to="{ name: 'editorial' }">Editorial</router-link>
      <router-link :to="{ name: 'curatorial' }">Curatorial</router-link> -->
      <br />
      <router-link :to="{ name: 'home' }">Image Overview</router-link>
      <router-link :to="{ name: 'list' }">List Overview</router-link>
      <br />
      <router-link :to="{ name: 'info' }">Info</router-link>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      menuActive: false
    };
  },
  methods: {
    goTo(category) {
      this.$root.$emit("goTo", "", category);
      this.$router.push({
        name: category
      });
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  padding: 0.25rem;
  .title {
    cursor: pointer;
  }
  .links {
    display: none;
    a,
    .link {
      display: block;
      cursor: pointer;
    }
  }
  &.active {
    width: 100%;
    height: 100%;
    background: white;
    .links {
      display: block;
    }
  }
}
</style>
